import { FunctionComponent } from "react";

const FooterFrame: FunctionComponent = () => {
  return (
    <div className="self-stretch bg-silver-100 flex flex-col items-center justify-start pt-5 px-[18px] pb-[18px] box-border gap-[82px] max-w-full text-left text-45xl text-black font-questrial mq450:gap-[20px] mq750:gap-[41px]">
      <div className="w-[1219px] h-[202px] flex flex-col items-start justify-start py-0 px-5 box-border gap-[10px] max-w-full">
        <div className="w-80 flex-1 relative flex items-center mq450:text-19xl mq1050:text-32xl">{`NAME: `}</div>
        <input
          className="[outline:none] bg-snow self-stretch h-24 relative box-border min-w-[250px] border-[1px] border-solid border-black"
          type="text"
        />
      </div>
      <div className="w-[1219px] h-[202px] flex flex-col items-start justify-start py-0 px-5 box-border gap-[10px] max-w-full">
        <div className="w-80 flex-1 relative flex items-center mq450:text-19xl mq1050:text-32xl">
          ADDRESS:
        </div>
        <input
          className="[outline:none] bg-snow self-stretch h-24 relative box-border min-w-[250px] border-[1px] border-solid border-black"
          type="text"
        />
      </div>
      <div className="w-[1219px] h-[202px] flex flex-col items-start justify-start py-0 px-5 box-border gap-[10px] max-w-full">
        <div className="w-80 flex-1 relative flex items-center mq450:text-19xl mq1050:text-32xl">
          PHONE:
        </div>
        <input
          className="[outline:none] bg-snow self-stretch h-24 relative box-border min-w-[250px] border-[1px] border-solid border-black"
          type="text"
        />
      </div>
      <div className="w-[1219px] h-[202px] flex flex-col items-start justify-start py-0 px-5 box-border gap-[10px] max-w-full">
        <div className="w-80 flex-1 relative flex items-center mq450:text-19xl mq1050:text-32xl">
          EMAIL:
        </div>
        <input
          className="[outline:none] bg-snow self-stretch h-24 relative box-border min-w-[250px] border-[1px] border-solid border-black"
          type="text"
        />
      </div>
      <div className="w-[1220px] flex flex-row items-start justify-start py-0 px-5 box-border max-w-full">
        <div className="w-[1127px] flex flex-col items-start justify-start gap-[10px] max-w-full">
          <div className="w-[421px] h-[93px] relative flex items-center shrink-0 max-w-full mq450:text-19xl mq1050:text-32xl">
            MESSAGE:
          </div>
          <textarea
            className="[border:none] bg-[transparent] h-[222px] w-auto [outline:none] self-stretch flex flex-row items-end justify-start py-[30px] px-6 box-border font-racing-sans-one text-45xl text-black"
            placeholder="SIGN UP"
            rows={11}
            cols={56}
          />
        </div>
      </div>
    </div>
  );
};

export default FooterFrame;
